import { render, staticRenderFns } from "./AvisosForm.vue?vue&type=template&id=63503266&scoped=true&"
import script from "./AvisosForm.vue?vue&type=script&lang=js&"
export * from "./AvisosForm.vue?vue&type=script&lang=js&"
import style0 from "./AvisosForm.vue?vue&type=style&index=0&id=63503266&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63503266",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCol,VContainer,VProgressCircular,VRow})
